import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null,
    loading: false,
    isCollapse: false,
    logoShow: false,
    uniquerouter: true,
    menus: [],
    rightNav: {},
    noMenuPages: [ // 没有菜单的页面
      {
        path: '/dashboard',
        title: '首页'
      },
      {
        path: '/user/profile',
        title: '个人信息'
      },
      {
        path: '/user/changepwd',
        title: '修改密码'
      },
      {
        path: '/safescore/scAudit',
        title: '记分审批'
      },
      {
        path: '/safescore/scAuditFinal',
        title: '提级审批'
      },
      {
        path: '/check/add',
        title: '新增隐患'
      },
      {
        path: '/abar/abarbeitung',
        title: '隐患整改'
      },
      {
        path: '/checkList/addFlow',
        title: '清单式排查'
      },
      {
        path: '/review/review',
        title: '隐患复查'
      },
      {
        path: '/review/reviewaudit',
        title: '隐患复查审核'
      },
      {
        path: '/MajorHazard/MajorHazard',
        title: '重大隐患处理'
      },
      {
        path: '/approvalList',
        title: '审批'
      },
      {
        path: '/report/reportEdit',
        title: '隐患信息'
      },
      {
        path: '/review/detail',
        title: '隐患详情'
      },
      {
        path: '/knowledgeBase/lawList',
        title: '法律法规'
      },
      {
        path: '/knowledgeBase/subList',
        title: '法律法规'
      },
      {
        path: '/HotWork/preliminaryAudit',
        title: '初步审核'
      },
      {
        path: '/HotWork/reportJobFire',
        title: '动火作业申请'
      },
      {
        path: '/HotWork/OnSiteAudit',
        title: '现场审核'
      },
      {
        path: '/HotWork/sign',
        title: '会签'
      },
      {
        path: '/HotWork/workCertificate',
        title: '作业证打印'
      },
      {
        path: '/HotWork/WhenHot',
        title: '动火作业'
      },
      {
        path: '/HotWork/acceptance',
        title: '验收'
      },
      {
        path: '/organization/user',
        title: '机构人员管理'
      },
      {
        path: '/hidden/list',
        title: '隐患查询'
      },
      {
        path: '/check/list',
        title: '隐患排查'
      },
      {
        path: '/lgnitionTask/preliminaryAudit',
        title: '初步审核'
      },
      {
        path: '/lgnitionTask/sign',
        title: '审批'
      },
      {
        path: '/lgnitionTask/workCertificate',
        title: '作业证打印'
      },
      {
        path: '/lgnitionTask/acceptance',
        title: '证件验收'
      },
      {
        path: '/lgnitionTask/whenHot',
        title: '证件作业'
      },
      {
        path: '/lgnitionTask/monitorCheck',
        title: '当班班长验票'
      },
      {
        path: '/limitTask/limitAnalysisDataExamine',
        title: '有限空间数据分析'
      },
      {
        path: '/limitTask/safetyMeasures',
        title: '有限空间安全措施'
      },
      {
        path: '/lgnitionTask/listBase',
        title: '安全措施'
      },
      {
        path: '/lgnitionTask/reportJobFire',
        title: '证件申请'
      },
      {
        path: '/messageList',
        title: '消息通知'
      },
      {
        path: '/sisetu',
        title: '四色图'
      },
      {
        path: '/workConditionMap',
        title: '工况总览'
      },
      {
        path: '/backlog',
        title: '首页待办'
      },
      {
        path: '/lgnitionTask/file',
        title: '证件归档'
      },
      {
        path: '/workSummary/list',
        title: '进行中的特殊作业'
      },
      {
        path: '/training/trainingSituation',
        title: '教育培训'
      },
      {
        path: '/EnterpriseFile/inspect',
        title: '设备点检记录'
      },
      {
        path: '/EnterpriseFile/maintain',
        title: '设备保养记录'
      },
      {
        path: '/trainingManagement/addProgram',
        title: '新增培训计划'
      },
      {
        path: '/trainingManagement/addLatoja',
        title: '新增线下培训'
      },
      {
        path: '/examination/addQuestion',
        title: '新增试题'
      },
      {
        path: '/examination/addQuestion',
        title: '新增试题'
      },
      {
        path: '/examination/addPaper',
        title: '新增试卷'
      },
      {
        path: '/examination/issueExam',
        title: '新增试卷'
      },
      {
        path: '/leftWok/workCertificate',
        title: '作业证打印'
      },
      {
        path: '/lgnitionTask/safetyEducation',
        title: '安全教育人确认',
      },
      {
        path: '/limitTask/preliminaryAudit',
        title: '初步审核',
      },
      {
        path: '/limitTask/limitDeptExamine',
        title: '审批',
      },
      {
        path: '/limitTask/workCertificate',
        title: '作业证打印',
      },
      {
        path: '/limitTask/safetyEducation',
        title: '安全教育人确认',
      },
      {
        path: '/limitTask/WorkAccept',
        title: '接受交底人确认',
      },
      {
        path: '/limitTask/whenHot',
        title: '作业',
      }, ,
      {
        path: '/limitTask/acceptance',
        title: '验收',
      },
      {
        path: '/blindTask/preliminaryAudit',
        title: '初步审核',
      },
      {
        path: '/blindTask/blindDeptExamine',
        title: '会签',
      },
      {
        path: '/blindTask/deptAudit',
        title: '审批',
      },
      {
        path: '/blindTask/workCertificate',
        title: '作业证打印',
      },
      {
        path: '/blindTask/safetyEducation',
        title: '安全教育人确认',
      },
      {
        path: '/blindTask/whenHot',
        title: '作业',
      },
      {
        path: '/blindTask/acceptance',
        title: '作业',
      },
      {
        path: '/highTask/preliminaryAudit',
        title: '初步审核',
      },
      {
        path: '/highTask/deptAudit',
        title: '审批',
      },
      {
        path: '/highTask/workCertificate',
        title: '作业证打印',
      },
      {
        path: '/highTask/safetyEducation',
        title: '安全教育人确认',
      },
      {
        path: '/highTask/whenHot',
        title: '作业',
      },
      {
        path: '/highTask/acceptance',
        title: '验收',
      },
      {
        path: '/groundTask/preliminaryAudit',
        title: '初步审核'
      },
      {
        path: '/groundTask/groundDeptExamine',
        title: '会签'
      },
      {
        path: '/groundTask/deptAudit',
        title: '动土作业审批'
      },
      {
        path: '/groundTask/workCertificate',
        title: '作业证打印'
      },
      {
        path: '/groundTask/whenHot',
        title: '作业'
      },
      {
        path: '/groundTask/safetyEducation',
        title: '安全教育人确认'
      },
      {
        path: '/groundTask/acceptance',
        title: '验收'
      },
      {
        path: '/roadBroken/whenHot',
        title: '证件作业'
      },
      {
        path: '/leftWok/sign',
        title: '审批'
      },
      {
        path: '/leftWok/safetyMeasures',
        title: '安全措施'
      },
      {
        path: '/leftWok/safetyEducation',
        title: '安全教育人确认'
      },
      {
        path: '/leftWok/WorkAccept',
        title: '接受交底人确认',
      },
      {
        path: '/leftWok/assignment',
        title: '作业'
      },
      {
        path: '/leftWok/acceptance',
        title: '验收'
      },
      {
        path: '/roadBroken/reportJobRoad',
        title: '断路安全作业重新申请'
      },
      {
        path:'/highTask/file',
        title: '证件归档',
      },
      {
        path: '/highTask/blindDeptExamine',
        title: '会签'
      },
      {
        path: '/highTask/safetyMeasures',
        title: '安全措施'
      },
      {
        path: '/limitTask/file',
        title: '证件归档'
      },
      {
        path: '/task/engineeringWork/file',
        title: '证件归档'
      },

      //  培训相关路由页 start
      {
        path: '/examination/course/addCourse',
        title: '新增课程'
      },
      {
        path: '/trainingManagement/addTeacher',
        title: '新增培训师资'
      },
      {
        path: '/trainingManagement/detailTeacher',
        title: '培训师资详情'
      },
      {
        path: '/trainingManagement/updateTeacher',
        title: '编辑培训师资'
      },
      {
        path: '/examination/course/addCourse',
        title: '新增培训课程'
      },
      {
        path: '/trainingManagement/safetyTrainingProgramSave',
        title: '新增安全培训计划'
      },
      {
        path: '/trainingManagement/safetyTrainingProgramEdit',
        title: '编辑安全培训计划'
      },
      {
        path: '/safetyTrainingProgram/details',
        title: '安全培训计划详情'
      },
      {
        path: '/safetyTrainingProgram/details/trainingObject',
        title: '培训对象'
      },
      {
        path: '/trainingManagement/task/publishTask',
        title: '下发任务'
      },
      {
        path: '/examination/examStatisticsDetail',
        title: '考试统计详情'
      },
      {
        path: '/trainingManagement/updateLatoja',
        title: '编辑线下培训记录'
      },
      {
        path: '/trainingManagement/detailLatoja',
        title: '线下培训记录详情'
      },
      {
        path: '/examination/updateQuestion',
        title: '编辑题库'
      },
      {
        path: '/examination/detailQuestion',
        title: '试题详情'
      },
      {
        path: '/trainingManagement/trainingResourceAdd',
        title: '新增培训课件'
      },
      {
        path: '/trainingManagement/trainingResourceUpdate',
        title: '编辑培训课件'
      },
      {
        path: '/examination/course/detailCourse',
        title: '课程详情'
      },
      {
        path: '/examination/course/updateCourse',
        title: '编辑课程'
      },
      //  培训相关路由页 end
      {
        path: '/blindTask/reportJobFire',
        title: '盲板抽堵作业重新申请'
      },
      {
        path: '/highTask/reportJobFire',
        title: '高处安全作业重新申请'
      },
      {
        path: '/groundTask/reportJobFire',
        title: '动土安全作业重新申请'
      },
      {
        path: '/roadBroken/file',
        title: '证件归档'
      },
      {
        path: '/groundTask/file',
        title: '证件归档'
      },
      {
        path: '/tempEle/file',
        title: '证件归档'
      },
      {
        path: '/leftWok/file',
        title: '证件归档'
      },
      {
        path: '/leftWok/file',
        title: '证件归档'
      },
      {
        path: '/blindTask/file',
        title: '证件归档'
      },
      {
        path: '/leftWok/preliminaryAudit',
        title: '初步审核'
      },
      {
        path: '/leftWok/reportJobFire',
        title: '吊装作业重新申请'
      },
      {
        path: '/roadBroken/preliminaryAudit',
        title: '初步审核'
      },
      {
        path: '/roadBroken/deptAudit',
        title: '审批'
      },
      {
        path: '/roadBroken/workCertificate',
        title: '作业证打印'
      },
      {
        path: '/roadBroken/safetyEducation',
        title: '安全教育人签字'
      },
      {
        path: '/roadBroken/whenHot',
        title: '作业证作业'
      },
      {
        path: '/roadBroken/acceptance',
        title: '作业证验收'
      },
      {
        path: '/tempEle/reportJobFire',
        title: '临时用电作业重新申请'
      },
      {
        path: '/tempEle/preliminaryAudit',
        title: '初步审核'
      },
      {
        path: '/roadBroken/sign',
        title: '会签'
      },
      {
        path: '/tempEle/sign',
        title: '会签'
      },
      {
        path: '/tempEle/workCertificate',
        title: '作业证打印'
      },
      {
        path: '/tempEle/safetyEducation',
        title: '安全教育人签字'
      },
      {
        path: '/tempEle/whenHot',
        title: '作业证作业'
      },
      {
        path: '/tempEle/acceptance',
        title: '作业证验收'
      },
      {
        path: '/limitTask/reportJobFire',
        title: '受限空间安全作业重新申请'
      },
      {
        path: '/tempEle/deptAudit',
        title: '审批'
      },
      {
        path: '/fourColorMap',
        title: '编辑四色图',
      },
      {
        path: '/picture/hiddenAudit',
        title: '随手拍审核',
      },
      {
        path: '/archives/osof/dir',
        title: '档案目录',
      },
      {
        path: '/checkSelf',
        title: '自检自查',
      },
      {
        path: '/hiddenAudit/detail',
        title: '隐患审核',
      },
      {
        path: '/lgnitionTask/analysisData',
        title: '分析数据'
      },
      {
        path: '/lgnitionTask/safetyMeasures',
        title: '安全措施'
      },
      {
        path: '/protectTask/preliminaryAudit',
        title: '劳保申请初审'
      },
      {
        path: '/protectTask/protectDeptExamine',
        title: '劳保申请审批'
      },
      {
        path: '/protectTask/warehouseConfirmation',
        title: '劳保发放'
      },
      {
        path: '/protectTask/receiveConfirm',
        title: '劳保领用'
      },
      {
        path: '/auditTask/file',
        title: '危险作业审批表'
      },
      {
        path: "/tempEle/analysisData",
        title: "临时用电数据分析",
      },
      {
        path: '/auditTask/hazardFile',
        title: '风险告知卡'
      },
      {
        path: '/preShiftMeeting/meetingRecord',
        title: '班前会记录表'
      },
      {
        path: '/lgnitionTask/WorkAccept',
        title: '动火接受交底人确认'
      },
      {
        path: '/highTask/WorkAccept',
        title: '高处作业接受交底人确认'
      },
      {
        path: '/workCertificatePreview_healthPromiseFile',
        title: '健康承诺书预览'
      },
      {
        path: '/task/gasWork/file',
        title: '煤气作业申请表预览'
      },
      {
        path: '/task/gasOperateRecord/file',
        title: '煤气操作表预览'
      },
      {
        path: '/riskPatrolTaskList',
        title: '巡查任务清单'
      }

    ],
    tabnavBox: [{
      title: '首页',
      path: '/dashboard'
    }]
  },
  mutations: {
    addTab(state, arg) {
      for (let i = 0; i < state.tabnavBox.length; i++) {
        if (state.tabnavBox[i].path === arg.path) {
          return false
        }
      }
      state.tabnavBox.push({
        title: arg.title,
        path: arg.path
      })
    },
    openMenu(state, arg) {
      state.rightNav = arg
    },
    removeTab(state, arg) {
      let index = state.tabnavBox.findIndex(function(value, key) {
        return value.path === arg.tabItem.path
      })
      state.tabnavBox.splice(index, 1)
      if (arg.tabItem.path === arg.fullPath) { // 移除当前导航时
        let tabActive = state.tabnavBox[index] || state.tabnavBox[index - 1]
        arg.router.push(tabActive.path)
      }
    },
    removeOtherTab(state, arg) {
      state.tabnavBox = [{
        title: '首页',
        path: '/dashboard'
      }]
      if (arg.all) {
        arg.router.push('/dashboard')
        return false
      }
      state.tabnavBox.push(arg.tabItem)
      arg.router.push(arg.tabItem.path)
    },
    collapse(state, arg) {
      state.isCollapse = !state.isCollapse
      if (state.logoShow) {
        setTimeout(function() {
          state.logoShow = false
        }, 300)
      } else {
        state.logoShow = true
      }
    },
  },
  actions: {
    addTab({
      commit
    }, arg) {
      commit('addTab', arg)
    },
    openMenu({
      commit
    }, arg) {
      commit('openMenu', arg)
    },
    removeTab({
      commit
    }, arg) {
      commit('removeTab', arg)
    },
    removeOtherTab({
      commit
    }, arg) {
      commit('removeOtherTab', arg)
    },
    collapse({
      commit
    }, arg) {
      commit('collapse', arg)
    },
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js